module.exports = __webpack_public_path__ + "static/media/Hero1.fbe4638b.webm";